export default "__VITE_ASSET__CSu3kYSN__"